

const Error = () => {

    return (
        <>
            <h1 className='GestorTitle'>Error</h1>
            <div className='ContLogin'>
                <h2>Hubo un inconveniente con tu pago. Por favor comuniquese con el administrador del sitio o intente realizar la compra en otro momento.</h2>
            </div>
        </>    
    )   
}

export default Error;